import { short_label as shortLabel } from './instant';
import { DEFAULT_CORNER } from '../../util_components/instant_alert/instant_popup_storage';
import type { InstantEntry } from '../../util_components/instant_alert/instant_alert_entries';
import type { InstantAlertConfig } from '../../util_components/instant_alert/types';

// Fired on window when this rep's claim proves a task is no longer pending.
export const INSTANT_GONE_EVENT = 'sales-task:instant-gone';

export const POPUP_STORAGE_KEY_PREFIX = 'sales_task_instant_popup_v1';

// Mirrors goserver's SALES-only claim gate.
export const SALES_CLAIM_ROLES = ['SALES'];

export const SALES_INSTANT_ALERT: InstantAlertConfig = {
  pendingPath: '/v2/sales_task_list/instant_pending',
  alertEventPath: '/v2/sales_task_list/alert_event',
  alertEventBody: (uuid, eventType) => ({ task_uuid: uuid, event_type: eventType }),
  listPath: '/sales-task-list',
  formHref: (uuid) => `/sales-task-form?uuid=${encodeURIComponent(uuid)}`,
  relayItemType: 'instant_task',
  relayClearedType: 'instant_task_cleared',
  capabilityKey: 'is_sales',
  storagePrefix: POPUP_STORAGE_KEY_PREFIX,
  defaultCorner: DEFAULT_CORNER,
  goneEvent: INSTANT_GONE_EVENT,
  normalize: (raw) => raw as unknown as InstantEntry,
  entryLabel: (entry) => shortLabel(entry.task_type, entry.task_label),
  title: 'Instant Task Alert',
  nounSingular: 'instant task',
  nounPlural: 'instant tasks',
  openLabel: 'Open task →',
  testIdPrefix: 'instant-alert'
};
